import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { uaToDeviceType } from '@cian/ui-kit/utils';

import { FC } from 'react';
import { Provider } from 'react-redux';

import { Amenities } from 'shared/components/Amenities';
import { AvailableSpaces } from 'shared/components/AvailableSpaces';
import { BreadCrumbs } from 'shared/components/BreadCrumbs';
import { Carousel } from 'shared/components/Carousel';
import { Description } from 'shared/components/Description';
import { GeoBlock } from 'shared/components/GeoBlock';
import { LearnMore } from 'shared/components/LearnMore/';
import { Specifications } from 'shared/components/Specifications';
import { StickyCoworkingCard } from 'shared/components/StickyCoworkingCard';
import { Title } from 'shared/components/Title';
import { Layout } from 'shared/components/UI/Layout';

import { FixedHeader } from '../FixedHeader';

import { IApplicationProps } from './types';

import styles from './App.css';

export const Application: FC<IApplicationProps> = props => {
  const { logger, reduxStore, customContext } = props;

  return (
    <ErrorLogComponent logger={logger}>
      <UiKitContextProvider deviceType={uaToDeviceType(customContext.userAgent)}>
        <Provider store={reduxStore}>
          <FixedHeader />
          <main className={styles['app']}>
            <BreadCrumbs />
            <Carousel />
            <Layout adaptiveStyles filled={false}>
              <div className={styles['content']}>
                <div className={styles['left-column']}>
                  <Title />
                  <GeoBlock className={styles['geo-block']} />
                  <Specifications className={styles['specifications']} />
                  <AvailableSpaces className={styles['available-spaces']} />
                  <Amenities />
                  <Description />
                  <LearnMore />
                </div>
                <aside className={styles['right-column']}>
                  <StickyCoworkingCard />
                </aside>
              </div>
            </Layout>
          </main>
        </Provider>
      </UiKitContextProvider>
    </ErrorLogComponent>
  );
};
